import FileCollection from './FileCollection'

export default FileCollection
